import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useLocation, withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import './index.scss';
import {
  getTranslateTitle,
  isSameObjects,
  mergeArrays,
  moveArrayItem,
} from '../../../utils/objects-util';
import { createAction } from '../../../utils/sagaHelper';
import {
  actionInitSectionItemsHeights,
  actionSetSectionItemsLoading,
} from '../../../store/reducers/sectionsWrapperData/sectionsWrapperData-actions';
import {
  actionUpdateSectionModelData,
  SECTION_MODEL_SCROLL_UPDATE
} from '../../../store/reducers/routing/routing-actions';

import getSectionComponent from '../SectionComponent';
import OrdersFilter from '../OrdersFilter';
import SectionItemsTitle from '../SectionItemsTitle';
import SectionInfoTitle from '../SectionInfoTitle/SectionInfoTitle';
import SectionTabs from '../SectionTabs';
import { USER_FILTER_ROLES } from '../../../utils/enums';
import CurrentShiftSwitchMode from '../CurrentShiftSwitchMode';
import { currentShiftSwitchModeItems } from '../../../utils/constants';
import CustomTableWrapper from "../CustomTable/CustomTableWrapper.jsx";

const DEFAULT_ITEMS_COUNT = 15;

class SectionWrapperCustomTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paginationPage: 0,
      itemsCount: 0,
      isOpenFilterBar: false,
      useDynamicRowHeight: props.sectionModel && !!props.sectionModel.tag,
      listRowsHeight: 0,
      dragIndex: null,
      totalItemsCount: 0,
      searchItems: [],
      sortedItems: null,
      saveDragModeLoader: false,
      isLastPaginationPage: false,
      filterRoles: this.getUsersFilterRoles(),
      filterSearch: props.sectionModel.getFilterOptionPropValue('search', 'selected') || ''
    };

    this.showedItems = [];
    this.timerId = null;
    this.timerIdPagination = null;

    this.getRowHeight = this.getRowHeight.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);

    this.scrollParentRef = React.createRef();
    this.sectionHeaderRef = React.createRef();
    this.infoTitleRef = React.createRef();
    this.isMobile = window.innerWidth < 1024;
  }

  componentDidMount() {
    const { isLoading } = this.props
    this.updateItemsData(null, true);
    this.forceUpdate();

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("dragover", this.handleOnDragOver);
    if (isLoading) {
      this.timerIdPagination = setTimeout(() => {
        this.handlePagination(null, false, true);
      }, [500]);

    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      items,
      sectionModel,
      sectionItemsHeights,
      rowHeightDefault,
      isLoading,
      pagination,
      filters,
    } = this.props;

    const {
      isOpenFilterBar,
      useDynamicRowHeight,
      listRowsHeight,
      dragIndex,
      sortedItems,
      totalItemsCount,
      itemsCount
    } = this.state;

    const isUpdateItems =
      sectionModel !== nextProps.sectionModel ||
      items !== nextProps.items ||
      sortedItems !== nextState.sortedItems;


    if (isUpdateItems) {
      this.updateItemsData(nextProps);
    }

    return isUpdateItems ||
      totalItemsCount !== nextState.totalItemsCount ||
      itemsCount !== nextState.itemsCount ||
      isLoading !== nextProps.isLoading ||
      this.props.searchValue !== nextProps.searchValue ||
      sectionItemsHeights !== nextProps.sectionItemsHeights ||
      rowHeightDefault !== nextProps.rowHeightDefault ||
      isOpenFilterBar !== nextState.isOpenFilterBar ||
      useDynamicRowHeight !== nextState.useDynamicRowHeight ||
      listRowsHeight !== nextState.listRowsHeight ||
      dragIndex !== nextState.dragIndex ||
      pagination !== nextState.pagination ||
      filters !== nextState.filters;
  }

  componentDidUpdate(prevProps, prevState) {
    const { items, sectionItemsHeights, rowHeightDefault, sectionModel } = this.props;
    if (prevProps.items !== items || sectionModel.isDraggable !== prevProps.sectionModel.isDraggable) {
      if (!this.isMobile) {
      }
    }

    if (sectionItemsHeights !== prevProps.sectionItemsHeights ||
      rowHeightDefault !== prevProps.rowHeightDefault
    ) {
      this.updateListHeights(prevProps.sectionItemsHeights, sectionItemsHeights);
    }

    this.updateListRowsHeights();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("dragover", this.handleOnDragOver);
    clearTimeout(this.timerId)
    clearTimeout(this.timerIdPagination)
  }

  _isDifferentItems(newItems, sectionModel) {
    const isSameLength = this.showedItems.length !== newItems.length;
    if (sectionModel.isForceUpdate) {
      return isSameLength ||
        this.showedItems.some((m, index) => !isSameObjects(m, newItems[index]));
    }

    return isSameLength ||
      this.showedItems.some((m, index) => m[sectionModel.key] !== newItems[index][sectionModel.key]);
  }


  updateItemsData = (props, isUpdateDragItems) => {
    const { sectionModel } = props || this.props;
    const { filterSearch } = this.state
    const newItems = this.getShowedItems(props || this.props);
    const isDifferentItems = this._isDifferentItems(newItems, sectionModel);

    if (isDifferentItems) {

      if (filterSearch && sectionModel.actionPagination) {
        this.showedItems = [];
      } else {
        this.showedItems = newItems;
      }
    }

    if (isUpdateDragItems && sectionModel.isDraggable) {
      this.setState({
        sortedItems: this.showedItems
          .map((showedItem, index) => ({ ...showedItem, [sectionModel.dragSortPropName]: index }))
      });
    }
  };

  updateListHeights = (prevItems, currentItems) => {

  };

  rowRenderer = ({ index, key, style }) => {
    const { dragIndex, sortedItems, saveDragModeLoader } = this.state;
    const { sectionModel, onLayout, items } = this.props;
    const item = (sortedItems && sortedItems[index]) || this.showedItems[index];
    if (!item) {
      return <div key={key} style={style} className={classNames("sectionComponent")}></div>;
    }
    const SectionComponent = getSectionComponent(sectionModel.tag);
    const usedSearch = items.length !== this.showedItems.length;
    return (
      <div key={key} style={style} className={classNames("sectionComponent", { "loading": saveDragModeLoader })}>
        <SectionComponent
          item={{ ...item, usedSearch }}
          dragIndex={dragIndex}
          index={index}
          sectionModel={sectionModel}
          filterOptions={sectionModel.filterOptions}
          saveDragModeLoader={saveDragModeLoader}
          onDragStart={this.handleOnDragStart}
          onDrop={this.handleOnDrop}
          onDragEnter={this.handleOnDragEnter}
          onRefreshPagination={() => sectionModel?.actionPagination && this.handlePagination(null, true)}
          onLayout={onLayout}
          onPropChange={this.handleOnPropChange}
        />
      </div>
    );
  };

  getRowHeight = ({ index }) => {
    const { sectionItemsHeights, sectionModel, rowHeightDefault } = this.props;
    const item = this.showedItems[index];
    if (!item) {
      return rowHeightDefault;
    }
    return sectionItemsHeights[item[sectionModel.key]] || rowHeightDefault;
  };

  getShowedItems = props => {
    const { items, sectionModel } = props || this.props;
    if (!sectionModel || !sectionModel.filterOptions) return items;
    return items || [];
  };

  getListRowsHeight = () => {
    const { rowHeightDefault } = this.props;
    const { useDynamicRowHeight } = this.state;
    if (!this.showedItems || !this.showedItems.length) return 0;
    return this.showedItems.reduce((a, b, index) => (a + (useDynamicRowHeight ? this.getRowHeight({ index }) : rowHeightDefault)), 0);
  };

  //Fix for container overheight
  updateListRowsHeights = isForceUpdate => {
    const { rowHeightDefault } = this.props;
    const { listRowsHeight } = this.state;
    const { clientHeight, scrollHeight } = (this.scrollParentRef && this.scrollParentRef.current) || {};
    const height = this.getListRowsHeight() + rowHeightDefault;
    const isOutside = clientHeight < (scrollHeight && clientHeight && scrollHeight);
    const headerHeight = (this.sectionHeaderRef && this.sectionHeaderRef.current)
      ? this.sectionHeaderRef.current.clientHeight
      : 0;

    if (
      this.prevHeight !== height ||
      this.sectionHeaderPrevHeight !== headerHeight ||
      isOutside ||
      isForceUpdate
    ) {
      let updatedHeight = isOutside ? (clientHeight - headerHeight) : height;
      updatedHeight = (updatedHeight > window.innerHeight) ? window.innerHeight : updatedHeight;

      if (updatedHeight !== listRowsHeight) {
        this.setState({ listRowsHeight: updatedHeight });
      }
    }

    this.prevHeight = height;
    this.sectionHeaderPrevHeight = headerHeight;
  };

  handleResize = () => {
    this.updateListRowsHeights(true);
    this.forceUpdate();
    // this.listRef.recomputeRowHeights();
  };

  handleOnOptionChange = (key, prop, value) => {
    const { sectionModel } = this.props;
    sectionModel.setFilterOption(key, prop, value);

    this.setState({ searchItems: [] });

    this.paginationFilter(key, value)

    this.isPropsChanged = true;
    if (!sectionModel.getFilterOptionPropValue(key, "isManualUpdate") && key === 'search') {
      this.updateItemsData();
      this.forceUpdate();
    }
  };

  handleOnFilterOrdersClose = (value, isStay) => {
    const { onFilterItemsClose } = this.props;
    const { filterRoles, filterSearch } = this.state;

    if (!value) {
      this.setState({ paginationPage: 1, isLastPaginationPage: false })
      this.paginationAction({
        num: 0,
        ...(filterSearch && { query: filterSearch }),
        roles: filterRoles
      })
    }

    if (!value && this.isPropsChanged && onFilterItemsClose) {
      onFilterItemsClose(isStay);
      this.isPropsChanged = false;
    }

    if (!isStay) {
      this.setState({ isOpenFilterBar: value || false });
    }

    this.updateItemsData();
    this.forceUpdate();
  };

  handleOnDrop = (e, item) => {
    const { sortedItems } = this.state;
    const { sectionModel } = this.props;

    this.setState({
      dragIndex: null,
      sortedItems: moveArrayItem(sortedItems, this.dragItem, item, sectionModel.dragSortPropName)
    });

    this.dragItem = null;
  }

  handleOnDragStart = (e, item) => {
    this.dragItem = item;
  }

  handleOnDragEnter = (e, index) => {
    this.setState({ dragIndex: index });
  }

  handleOnDragOver = e => {
    e.preventDefault();
  }

  handleOnPropChange = propValue => {
    const { sectionModel, itemAction } = this.props;
    if (sectionModel.editAction) {
      itemAction(sectionModel.editAction, propValue);
    }
  }

  handleOnUpdateSectionModelData = data => {
    const { sectionModel, updateSectionModelData } = this.props;
    updateSectionModelData({ typeModel: sectionModel.typeModel, data });
    this.forceUpdate();
  }

  handleOnSetDragMode = () => {
    const { sectionModel } = this.props;
    this.handleOnUpdateSectionModelData({ isDraggable: true });
    this.setState({
      sortedItems: this.showedItems
        .map((showedItem, index) => ({ ...showedItem, [sectionModel.dragSortPropName]: index }))
    });
  }

  handleOnMobileDrag = items => {
    this.setState({ sortedItems: items });
  };

  handleOnSaveDragChanges = () => {
    this.setState({ saveDragModeLoader: true });
    const { sortedItems } = this.state;
    const { sectionModel, itemAction } = this.props;
    if (sectionModel.dragActionName) {
      itemAction(sectionModel.dragActionName, {
        model: sectionModel,
        data: sortedItems,
      });
    }

    this.setState({ dragIndex: null, sortedItems: null });
    this.timerId = setTimeout(() => {
      this.setState({ saveDragModeLoader: false });
      this.handleOnUpdateSectionModelData({ isDraggable: false })
    }, 1500)
  };

  handleOnFilterClick = () => {
    const { isOpenFilterBar } = this.state;
    this.handleOnFilterOrdersClose(!isOpenFilterBar);
  };

  getListRowHeight = (enabledCurrentSwitchMode) => {
    const { sectionModel } = this.props
    const { listRowsHeight } = this.state
    const { clientHeight: infoTitleHeight } = this.infoTitleRef?.current || {}
    const maxListHeight = window.innerHeight - 60 - 55 -
      (sectionModel.footer ? 90 : 0) -
      (enabledCurrentSwitchMode ? 120 : 0) -
      (infoTitleHeight ? infoTitleHeight * 2 : 0);

    return listRowsHeight > maxListHeight ? maxListHeight : listRowsHeight
  }

  showSearchItemsAmount = () => {
    const { pathname } = useLocation();
    return pathname === "/orders"
  }

  handlePagination = (event, isForceUpdate = false, updateAfterLoad = false) => {
    const { sectionModel, rowHeightDefault, isLoading, updateScrollPosition } = this.props
    const { useDynamicRowHeight, paginationPage, isLastPaginationPage, filterRoles, filterSearch, totalItemsCount, itemsCount } = this.state
    const { clientHeight, scrollHeight, scrollTop } = event || {}

    if (scrollTop && updateScrollPosition && sectionModel.fixScroll) {
      updateScrollPosition({ scroll: scrollTop, typeModel: sectionModel.typeModel });
    }

    let newItemsCount = itemsCount

    if (!isForceUpdate) {
      if (!sectionModel?.actionPagination || isLoading || isLastPaginationPage) return
      // calc items in page (count)
      const enabledCurrentSwitchMode = currentShiftSwitchModeItems.some(mode => mode.link === sectionModel.typeModel);
      const listHeight = window.innerHeight - (enabledCurrentSwitchMode ? 235 : 122)
      const rowHeight = useDynamicRowHeight ? this.getRowHeight : rowHeightDefault
      newItemsCount = +(listHeight / rowHeight).toFixed(0)
      // calc items in page end (count)

      // should users update
      const isUpdateUsers = (scrollHeight - clientHeight - 60) < scrollTop
      // should users update end

      if (updateAfterLoad) {
        this.paginationAction({ num: isForceUpdate ? 0 : paginationPage, count: newItemsCount, query: filterSearch, roles: filterRoles })
      }
      if (!isUpdateUsers || isLoading) return

      if (totalItemsCount && this.showedItems?.length && totalItemsCount <= this.showedItems?.length) {
        this.setState({ isLastPaginationPage: true })
        return;
      }

      this.setState({ paginationPage: paginationPage + 1, itemsCount: newItemsCount })
    }

    if (isForceUpdate) {
      this.setState({ paginationPage: 0, isLastPaginationPage: false })
    }
    this.paginationAction({ num: isForceUpdate ? 0 : paginationPage, count: newItemsCount, query: filterSearch, roles: filterRoles })
  }

  paginationAction = (params) => {
    const { dispatch, sectionModel, setSectionItemsLoading } = this.props
    const { paginationPage, itemsCount, filterRoles, searchItems } = this.state

    if (!sectionModel?.actionPagination) return

    const paginationParams = {
      num: paginationPage,
      ...(itemsCount && { count: itemsCount }),
      ...(filterRoles && { roles: filterRoles }),
      filters: { ...(sectionModel?.filterOptions?.options || {}) },
      ...params
    }

    if (!paginationParams.count) {
      paginationParams.count = DEFAULT_ITEMS_COUNT;
    }

    const newItems = (users) => paginationPage ?
      mergeArrays(searchItems, users, sectionModel.paginationKey || 'userId', sectionModel.paginationKey || 'userId') :
      users

    dispatch(createAction(sectionModel.actionPagination, paginationParams))
      .then((data) => {
        this.setState({ totalItemsCount: data?.totalCount || 0 })
        if (params.query) {
          this.setState({ searchItems: newItems(data?.users) })
          this.showedItems = newItems(data?.users)
        }
        setSectionItemsLoading(false)
      }).finally(() => {
        setSectionItemsLoading(false)
      })
  }

  getUsersFilterRoles() {
    const { sectionModel } = this.props;
    const rolesValues = Object.keys(sectionModel?.filterOptions?.options || {})
    const roles = []

    rolesValues.forEach(item => {
      if (USER_FILTER_ROLES[item]) {
        const isSelected = sectionModel.getFilterOptionPropValue(item, 'selected')
        if (isSelected) {
          roles.push(USER_FILTER_ROLES[item])
        }
      }
    })

    return roles
  }

  paginationFilter = (key, value) => {
    const { sectionModel } = this.props
    const { filterSearch } = this.state
    const isSearchKey = key === 'search'
    const newValue = typeof value === 'string' ? value?.replace(/-/gi, '') : ''

    // user roles
    const roles = this.getUsersFilterRoles()
    // user roles end

    const searchValue = isSearchKey ? newValue : filterSearch
    this.setState({ filterRoles: roles, filterSearch: searchValue })

    // filter action

    if (searchValue?.length && isSearchKey) {
      this.setState({ paginationPage: 1, isLastPaginationPage: false })
      this.paginationAction({ num: 0, query: searchValue })
    }
    // filter action end

    //reset pagination if clear search
    if (!searchValue?.length && isSearchKey && sectionModel?.actionPagination) {
      this.setState({ paginationPage: 1, isLastPaginationPage: false })
      this.paginationAction({ num: 0 })
    }
    //reset pagination if clear search end
  }

  render() {
    const { t, reportComponent, addComponent, customTableConfig, onSelectRow, onSetTableFilter, summaryComponent, onSetTablePagination, customHeader,
      onRefreshData, sectionModel, onBack, searchValue, setSearchValue, onLayout, i18n, isLoading, onChangeData, filter,
      onSetFilter, handleOnSaveReport, periodControl, filters, pagination, keyForDate, showAutoRefresh, isAutoRefresh } = this.props;
    const { isOpenFilterBar, saveDragModeLoader, totalItemsCount, hideSectionItemTitle } = this.state;

    const enabledCurrentSwitchMode = currentShiftSwitchModeItems.some(mode => mode.link === sectionModel.typeModel);

    return (
      <div
        key={'SectionWrapper'}
        className={classNames('sectionWrapper', { tabs: !!sectionModel.tabs || sectionModel.tabsControls.length })}
      >
        <div className={classNames('ordersFilterWrapper', { isOpen: isOpenFilterBar })}>
          <OrdersFilter
            filterOptionsModel={sectionModel.filterOptions}
            onChangeOption={(key, prop, value) => this.handleOnOptionChange(key, prop, value)}
            onClose={this.handleOnFilterOrdersClose}
          />
        </div>
        {hideSectionItemTitle && (
          <SectionItemsTitle
            sectionModel={sectionModel}
            isOpenFilterBar={isOpenFilterBar}
            items={this.showedItems}
            itemsCount={totalItemsCount || this.showedItems?.length}
            searchValue={searchValue}
            onOptionChange={this.handleOnOptionChange}
            onFilterOrdersClose={this.handleOnFilterClick}
            onLayout={onLayout}
            saveDragModeLoader={saveDragModeLoader}
            onSetDragMode={this.handleOnSetDragMode}
            onSaveDragChanges={this.handleOnSaveDragChanges}
            onUpdateSectionModelData={this.handleOnUpdateSectionModelData}
            showSearchItemsAmount={this.showSearchItemsAmount}
            systemLanguage={i18n?.language}
            onBack={onBack}
          />
        )}
        <SectionInfoTitle infoTitleRef={this.infoTitleRef} styles={{ margin: '0 20px 20px' }} sectionModel={sectionModel} />
        {!!customHeader && (
          <div ref={this.sectionHeaderRef} className={classNames('sectionItemsWrapperHeader')}>
            {customHeader}
          </div>
        )}
        {enabledCurrentSwitchMode && <CurrentShiftSwitchMode />}
        <SectionTabs model={sectionModel} />
        <div className={classNames('mobileTableWrapper')}>
          <div className={classNames('sectionItemsWrapper')}>
            <div className={'itemsWrapper custom'}>
              <div className={classNames('items')}>
                <CustomTableWrapper
                  showAutoRefresh={showAutoRefresh}
                  isAutoRefresh={isAutoRefresh}
                  customTableConfig={customTableConfig}
                  reportComponent={reportComponent}
                  addComponent={addComponent}
                  onSelectRow={onSelectRow}
                  summaryComponent={summaryComponent}
                  keyForDate={keyForDate}
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  onRefreshData={onRefreshData}
                  onChange={onChangeData}
                  loading={isLoading}
                  data={this.showedItems}
                  id={sectionModel.typeModel}
                  columns={sectionModel.columns.map(item => ({
                    ...item,
                    render: item.component,
                    title: getTranslateTitle(item.title),
                    dataIndex: item.accessor,
                    key: item.accessor,
                    align: item.align || 'left',
                  }))}
                  filter={filter}
                  onSetFilter={onSetFilter}
                  handleOnSaveReport={handleOnSaveReport}
                  periodControl={periodControl}
                  t={t}
                  filters={filters}
                  pagination={pagination}
                  onSetTablePagination={data => onSetTablePagination(data)}
                  onSetTableFilter={data => onSetTableFilter(data)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: state.sectionsWrapperData.isLoading,
    sectionItemsHeights: state.sectionsWrapperData.heights,
    rowHeightDefault: state.sectionsWrapperData.rowHeightDefault,
    translationsLanguage: state.i18n?.language,
    scrolls: state.sectionModel.scrolls,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
    itemAction: (action, data) => dispatch(createAction(action, data)),
    initSectionItemsHeights: () => dispatch(actionInitSectionItemsHeights()),
    setSectionItemsLoading: data => dispatch(actionSetSectionItemsLoading(data)),
    updateSectionModelData: data => dispatch(actionUpdateSectionModelData(data)),
    updateScrollPosition: data => dispatch(createAction(SECTION_MODEL_SCROLL_UPDATE, data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(SectionWrapperCustomTable))
);

